import { ratingArray } from "constants/list"
import { t } from "i18next"
import { localisedValue, mapKeysToValues } from "utils"

const leadReviewTransformer = response => {
  const data = response?.data?.map((item, index) => {
    const feedbackFieldsMapping = item?.Feedback?.FeedbackFields?.reduce((acc, item) => {
      const name = item.FeedbackFieldType?.name
      if (name) {
        acc[name] = item
      }
      return acc
    }, {})
    const call = feedbackFieldsMapping["Call Recordings"]
    const progress = feedbackFieldsMapping["Progress On Task"]
    const reviewConcerns = improvements => {
      if (!improvements || !improvements.length) return [t("No Concerns")]
      return improvements.map(item =>
        item?.InternalInquiryAreasOfImprovement?.key === "other"
          ? item?.otherImprovement
          : localisedValue({ object: item?.InternalInquiryAreasOfImprovement, key: "title" })
      )
    }
    const reviewer = {
      name: localisedValue({ object: item?.Feedback?.reviewer, key: "name" }),
      city: localisedValue({ object: item?.Feedback?.reviewer?.City, key: "name" }),
      designation: localisedValue({ object: item?.Feedback?.reviewer?.UserDesignation, key: "short" }),
    }
    const ratingObject = mapKeysToValues(ratingArray(), "id", "label")
    const breakdown =
      item?.type === "audit_review"
        ? [
            {
              trait: t("Client Interest"),
              feedback: !!item?.clientInterested ? t("Interested") : t("Not Interested"),
              tags: [
                ...(item?.InternalInquiryClientNotInterestedReason?.key !== "other"
                  ? [{ label: localisedValue({ object: item.InternalInquiryClientNotInterestedReason, key: "title" }) }]
                  : []),
                ...(item?.clientNotInterestedReasonValue
                  ? [{ label: localisedValue({ object: item, key: "clientNotInterestedReasonValue" }) }]
                  : []),
              ],
            },
            {
              trait: t("Audit Concerns"),
              feedback: reviewConcerns(item?.InquiryFeedbackAreasOfImprovementMappings)?.join(", "),
            },
            { trait: t("Overall"), feedback: localisedValue({ object: item?.Feedback, key: "feedback" }) },
          ]
        : [
            ...(item?.Feedback?.FeedbackFields?.map(field => ({
              trait: localisedValue({ object: field?.FeedbackFieldType, key: "name" }),
              tags: [{ label: ratingObject[field?.rating] }],
              comment: localisedValue({ object: field, key: "comment" }),
            })) || []),
            {
              trait: t("Proposed Next Task"),
              tags: [{ label: localisedValue({ object: item?.TaskType, key: "name" }) }],
            },
            { trait: t("Overall"), feedback: localisedValue({ object: item?.Feedback, key: "feedback" }) },
          ]

    return {
      ...item,
      lead: {
        id: item?.InternalInquiry?.id,
        flagIds: item?.InternalInquiry?.InternalInquiryCategoryMappings?.map(category => category?.inquiryCategoryId),
      },
      Feedback: { call, progress, ...item?.Feedback },
      reviewType: item?.type === "audit_review" ? t("Audit") : t("Lead"),
      showAlertIcon: item?.type === "audit_review",
      classificationKey: item?.InternalInquiry?.InternalInquiryClassification?.key,
      isAddedToWatchList: item?.InternalInquiry?.InternalInquiryWatchlists?.length,
      isFlagged: item?.InternalInquiry?.InternalInquiryCategoryMappings?.length > 0,
      leadCreated: item?.InternalInquiry?.createdAt,
      reviewCreated: item?.createdAt,
      reviewer,
      breakdown,
      feedback: localisedValue({ object: item?.Feedback, key: "feedback" }),
    }
  })
  return {
    ...response,
    data,
  }
}

export default leadReviewTransformer
